import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, message, Modal } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import PdButton from 'components/pd-button';
import './style.scss';
import Expand from 'react-expand-animated';
import { get } from 'lodash';
import CategoryService from 'services/category';
const { confirm } = Modal;

export default function TreeCategory({
  data,
  children,
  titleWidth = 0,
  titleOffset = 0,
  listOpen,
  openClose,
  getCategories,
}) {
  async function deleteCategory(id) {
    try {
      if (id) {
        await CategoryService.deleteCategory(id);
        message.success('Successfully removed category');
      }
    } catch (err) {
      const errMessage = get(err, 'response.data.message', '');
      if (errMessage) {
        message.error(errMessage);
      } else {
        message.error('Cannot connect to server, please check connection');
      }
    } finally {
      getCategories();
    }
  }

  async function hideCategory(id) {
    try {
      if (id) {
        await CategoryService.hideCategory(id);
        message.success('successfully hide category');
      }
    } catch (err) {
      const errMessage = get(err, 'response.data.message', '');
      if (errMessage) {
        message.error(errMessage);
      } else {
        message.error('Cannot connect to server, please check connection');
      }
    } finally {
      getCategories();
    }
  }

  async function handleRestore(id) {
    try {
      if (id) {
        await CategoryService.restoreCategory(id);
        message.success('Successfully restored category');
      }
    } catch (err) {
      const errMessage = get(err, 'response.data.message', '');
      if (errMessage) {
        message.error(errMessage);
      } else {
        message.error('Cannot connect to server, please check connection');
      }
    } finally {
      getCategories();
    }
  }

  function handleHide(id) {
    confirm({
      title: 'Are you sure you want to hide this category?',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        hideCategory(id);
      },
      onCancel() {},
    });
  }

  function handleDelete(id) {
    confirm({
      title: 'Are you sure you want to delete this category?',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        deleteCategory(id);
      },
      onCancel() {},
    });
  }

  function displayStatus(status) {
    if (status === '') {
      return '';
    } else {
      return status.charAt(0).toUpperCase() + status.slice(1);
    }
  }

  return (
    <div className="tree-category">
      <Row type="flex" align="middle" gutter={5}>
        <Col
          span={1}
          offset={titleOffset}
          className="toggle"
          onClick={() =>
            listOpen.includes(data.id)
              ? openClose('close', data.id)
              : openClose('open', data.id)
          }>
          {get(data, 'subcategories', []).length > 0 ? (
            listOpen.includes(data.id) ? (
              <UpOutlined />
            ) : (
              <DownOutlined />
            )
          ) : (
            <></>
          )}
        </Col>
        <Col span={titleWidth}>
          <div className="pd-cms-category--text">
            <span className="table-title--sort">{data.title}</span>
          </div>
        </Col>
        <Col span={2} offset={1}>
          <div className="pd-cms-category--text">
            <div className="status-indicator">
              <span
                className={data.status !== 'inactive' ? 'active' : 'hidden'}>
                {displayStatus(data.status)}
              </span>
            </div>
          </div>
        </Col>
        <Col span={6}>
          <div className="button-table">
            <Row>
              <Col span={12} className="button">
                {data.status === 'active' ? (
                  <PdButton
                    type="danger"
                    outline
                    full
                    style={{ height: 32 }}
                    onClick={() => {
                      handleHide(data.id);
                    }}>
                    Deactivate
                  </PdButton>
                ) : (
                  <PdButton
                    type="primary"
                    outline
                    full
                    style={{ height: 32 }}
                    onClick={() => handleRestore(data.id)}>
                    Reactivate
                  </PdButton>
                )}
              </Col>
              <Col span={12} className="button">
                {data.status === 'active' ? (
                  <Link
                    to={{
                      pathname: `/categories/edit`,
                      search: `?id=${data.id}`,
                    }}>
                    <PdButton type="primary" full style={{ height: 32 }}>
                      Edit
                    </PdButton>
                  </Link>
                ) : (
                  <PdButton
                    onClick={() => {
                      handleDelete(data.id);
                    }}
                    type="danger"
                    full
                    style={{ height: 32 }}>
                    Delete
                  </PdButton>
                )}
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      {get(data, 'subcategories', []).length > 0 && (
        <Expand open={listOpen.includes(data.id)}>
          <div className="content-tree">{children}</div>
        </Expand>
      )}
    </div>
  );
}
